import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import CarouselImage from './CarouselImage';
import LeftArrow from './LeftArrow';
import RightArrow from './RightArrow';
import { SpaceShape } from 'venuescanner-js/react/shapes';
import SpaceLink from './SpaceLink';
import getImage from '../../helpers/getImage';

const Carousel = ({ space, ga, includeSrpFilters }) => {
  const { photos } = space;
  const showArrows = photos?.length > 1;
  const ref = React.useRef(null);
  const [loaded, setLoaded] = React.useState(false);
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
  const move = useCallback(
    delta => {
      let nextIdx = currentPhotoIndex + delta;
      if (nextIdx >= photos?.length) nextIdx = 0;
      else if (nextIdx < 0) nextIdx = photos.length - 1;
      setCurrentPhotoIndex(nextIdx);
    },
    [currentPhotoIndex, setCurrentPhotoIndex, photos],
  );

  const moveLeft = useCallback(
    e => {
      e.preventDefault();
      move(-1);
    },
    [move],
  );

  const moveRight = useCallback(
    e => {
      e.preventDefault();
      move(1);
    },
    [move],
  );

  useEffect(() => {
    // if (typeof window === 'undefined') return
    // if (loaded) return
    const observer = new IntersectionObserver(intersections => {
      intersections.forEach(int => {
        if (int.isIntersecting) {
          setLoaded(true);
          observer.disconnect();
        }
      });
    });
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, loaded, setLoaded, space.hashcode]);
  return (
    <div className='space-tile__carousel'>
      {showArrows && <LeftArrow onClick={moveLeft} />}

      <SpaceLink space={space} ga={ga} includeSrpFilters={includeSrpFilters}>
        <div className='space-tile__viewport' ref={ref}>
          <div
            className='space-tile__viewport__collection'
            data-testid='viewportCollection'
            style={{ transform: `translateX(-${currentPhotoIndex * 100}%)` }}>
            {photos?.map((p, i) => (
              <CarouselImage
                isMain={i == 0}
                isActive={loaded && i === currentPhotoIndex}
                src={getImage(p, 'med')}
                key={i}
                alt={`${space.venue_name} ${space.name} ${i}`}
                spaceHash={`space-${space.hashcode}`}
              />
            ))}
          </div>
        </div>
      </SpaceLink>

      {showArrows && <RightArrow onClick={moveRight} />}
    </div>
  );
};

Carousel.propTypes = {
  space: SpaceShape.isRequired,
  ga: PropTypes.string.isRequired,
  includeSrpFilters: PropTypes.bool,
};

export default Carousel;
